import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.domain.contact.update;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_CONTACT_UPDATE',
	url: '/network/dns/domain/contact/update.json',
});

export { actions, reducer, sagas, selectors };
